import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Row,Col, Card, Form, Button, Modal} from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import axios from 'axios';
import {Drawer} from 'antd';

import PsContext from '../../context/PsContext';
import UpdateTs from './UpdateTs';

class TsValue extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showTsEdit: false,
		}
		
		this.handleTsEditClick = this.handleTsEditClick.bind(this);
		this.handleTsEditClose = this.handleTsEditClose.bind(this);
	}
	
	componentDidMount(){
		
		/* this.context.updateHeader({
			top: false,
			title: 'Policy',
			back: true,
		}); */
		
	}
	
	componentWillUnmount(){
		
		//this.context.updateHeader({top: false});		
	}
	
	handleTsEditClose(){
		this.setState({
			showTsEdit: false,
		});
	}
	
	handleTsEditClick(){
		this.setState({
			showTsEdit: true,
		});
	}
	
	render(){

		return(
			<div className="bg-gradient-streaks py-10 px-10" >
				<Row>
					<Col xs={9} >
						<label className="text-secondary" >TS Value</label>
						<h5 className="text-white" >{this.context.state.company.ts_value}</h5>
					</Col>
					<Col xs={3} >
						<div className="text-right font-20 mt-15 text-white"  style={{float:'right'}} >
							<a href="javascript:;" className="text-white" onClick={this.handleTsEditClick}  >
								<i className="icofont-pen-alt-2"></i>
							</a>
						</div>
					</Col>
				</Row>		

				  <Drawer
					  placement={"bottom"}
					  closable={true}
					  onClose={this.handleTsEditClose} 
					  visible={this.state.showTsEdit}
					  height={'300px'}
					  title="Update"
					>
					
						<UpdateTs />
					
					</Drawer>
				
			</div>
		);
	}
	
}
export default TsValue;
